import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { validateStep2 as validate } from './validations';
import normalizePhone from '../Widget/normalizePhone';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import CheckboxGroup from '../CheckboxGroup';
import DropDownSelect from '../DropDownSelect';

import GetUpdatesCheckbox from '../Widget/GetUpdatesCheckbox';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupWrapper,
    MultipleGroupFull,
    MultipleGroupLastLarge,
    OnSubmitValidator
} from '../../containers/DefaultStyles/FormDetails';
import submissionErrorHandler from '../../utils/submissionErrorHandler';

import { LoadingSpinner } from '../../components/LoadingSpinner';

const MultipleGroupFullSmall = styled(MultipleGroupFull)`
    margin-bottom: 0.2em;
`;

class VoteRegistrationStep2Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: submissionErrorHandler(props.currentFormValues, validate)
        };
        this.clearSubmitErrors = this.clearSubmitErrors.bind(this);
    }

    componentDidMount() {
        this.setState({ errors: [] });
    }

    setSubmitErrors(errors) {
        this.setState({ errors });
    }

    checkForBlurError(name) {
        const errors = submissionErrorHandler(this.props.currentFormValues, validate);
        if (errors.includes(name) && !this.state.errors.includes(name))
            this.setState({ errors: [...this.state.errors, name] });
    }

    clearSubmitErrors(fieldName) {
        if (fieldName && this.state.errors.includes(fieldName)) {
            this.setState({ errors: this.state.errors.filter(e => e !== fieldName) });
        }
    }

    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupLastLarge>
                    <Field
                        name="homeAddress"
                        onBlur={() => this.checkForBlurError('homeAddress')}
                        submissionError={this.state.errors.includes('homeAddress')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Street No & Street"
                        placeholder="Street No & Street"
                        autocomplete="off"
                    />
                    <Field
                        name="unit"
                        component={InputGroup}
                        type="text"
                        label="Unit"
                        placeholder="Unit"
                        autocomplete="off"
                    />
                </MultipleGroupLastLarge>
                <MultipleGroupFull>
                    <Field
                        name="homeCity"
                        onBlur={() => this.checkForBlurError('homeCity')}
                        submissionError={this.state.errors.includes('homeCity')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Home city"
                        placeholder="Home City"
                        autocomplete="off"
                    />
                </MultipleGroupFull>
                <MultipleGroupWrapper>
                    <Field
                        name="stateId"
                        onBlur={() => this.checkForBlurError('stateId')}
                        submissionError={this.state.errors.includes('stateId')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={DropDownSelect}
                        options={this.props.states}
                        defaultOption={'Choose'}
                        label="State"
                        type="text"
                    />
                    <Field
                        name="postalCode"
                        onBlur={() => this.checkForBlurError('postalCode')}
                        submissionError={this.state.errors.includes('postalCode')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Postal code"
                        placeholder="Postal Code"
                        autocomplete="off"
                        maxLength={5}
                    />
                    <Field
                        name="phone"
                        onBlur={() => this.checkForBlurError('phone')}
                        submissionError={this.state.errors.includes('phone')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Phone"
                        placeholder="Phone"
                        autocomplete="off"
                        normalize={normalizePhone}
                    />
                </MultipleGroupWrapper>
                <MultipleGroupFullSmall>
                    <Field
                        name="smsUpdates"
                        defaultChecked={true}
                        component={CheckboxGroup}
                        label="I'd like to receive SMS updates"
                        normalize={v => !!v}
                    />
                    <Field
                        name="confirmationEmail"
                        defaultChecked={true}
                        component={CheckboxGroup}
                        label="Send confirmation email"
                        normalize={v => !!v}
                    />
                </MultipleGroupFullSmall>
                <MultipleGroupFull>
                    <GetUpdatesCheckbox
                        style={{ paddingTop: `0px` }}
                        labelText="I'd like to receive email updates"
                        isEU={this.props.endUserLocation.isEU}
                    />
                </MultipleGroupFull>
                <ButtonGroupWrapper
                    isFormSubmitting={this.props.isAddressSubmitting}
                    rightPosition={23}
                >
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <OnSubmitValidator
                            onClick={e => {
                                e.preventDefault();
                                const errors = submissionErrorHandler(
                                    this.props.currentFormValues,
                                    validate
                                );
                                if (errors.length === 0 && !this.props.invalid) {
                                    this.props.handleSubmit();
                                } else {
                                    this.setSubmitErrors(errors);
                                }
                            }}
                        >
                            <Button
                                primary={true}
                                type="submit"
                                label="Continue"
                                className="submitButton"
                                disabled={this.props.invalid}
                                isSubmitting={this.props.isFormSubmitting}
                            />
                        </OnSubmitValidator>
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep2Form.propTypes = {
    currentFormValues: PropTypes.object,
    endUserLocation: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    isAddressSubmitting: PropTypes.bool,
    isFormSubmitting: PropTypes.bool,
    onBack: PropTypes.func,
    states: PropTypes.array
};

export default compose(
    connect(state => {
        return {
            initialValues: {
                postalCode:
                    state.cachedFormData.postalCode ||
                    (state.localRep.localRepData.address || {}).zipCode ||
                    state.widget.endUserLocation?.postalCode ||
                    '',
                stateId:
                    state.cachedFormData.stateId ||
                    (state.localRep.localRepData.address || {}).state ||
                    state.widget.endUserLocation?.region ||
                    '',
                homeCity:
                    state.cachedFormData.homeCity ||
                    (state.localRep.localRepData.address || {}).city ||
                    state.widget.endUserLocation?.city ||
                    '',
                homeAddress: state.cachedFormData.homeAddress || '',
                unit: state.cachedFormData.unit || '',
                phone: state.cachedFormData.phone || '',
                smsUpdates: true,
                confirmationEmail: true,
                getUpdates: !(state.widget.endUserLocation || {}).isEU
            },
            endUserLocation: state.widget.endUserLocation || {},
            currentFormValues: (state.form['voteRegistrationStep2Form'] || {}).values
        };
    }),
    reduxForm({
        form: 'voteRegistrationStep2Form',
        destroyOnUnmount: false,
        enableReinitialize: false,
        validate
    })
)(VoteRegistrationStep2Form);
